// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://eorjivfwnfemrpgrcpxu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVvcmppdmZ3bmZlbXJwZ3JjcHh1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIwMDgzOTUsImV4cCI6MjA3NzU4NDM5NX0.mMLjV9Gz-eofv1qOVu30G5z4ERKSc1wdnTapxv0fdPM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});